var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4558 20.7164L19.4555 20.7168L19.4644 20.7234C19.8168 20.9849 20.3168 20.956 20.6364 20.6363C20.9878 20.2849 20.9878 19.7151 20.6364 19.3636L15.8304 14.5575C16.8137 13.3013 17.4 11.7189 17.4 10C17.4 5.9131 14.0869 2.6 10 2.6C5.9131 2.6 2.6 5.9131 2.6 10C2.6 14.0869 5.9131 17.4 10 17.4C11.7189 17.4 13.3013 16.8137 14.5575 15.8304L19.3636 20.6364L19.3633 20.6367L19.3717 20.6438L19.4558 20.7164ZM4.4 10C4.4 6.9072 6.9072 4.4 10 4.4C13.0928 4.4 15.6 6.9072 15.6 10C15.6 13.0928 13.0928 15.6 10 15.6C6.9072 15.6 4.4 13.0928 4.4 10Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.f1fd9c1b2c97ab925450eaee1cf9396d.svg";
export { ForwardRef as ReactComponent };